<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="8" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb />
                </nav>
                </b-col>

            </b-row>
        </base-header>
        <b-container fluid class="mt--6 container-padding">
            <div>
                <loading :active="loadingCounter > 0" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
            </div>
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <card>
                            <div slot="header" class="mb-0">
                                <h4>{{language_terms['UPLOAD_DOCUMENT']}}</h4>
                            </div>
                            <b-row>
                                <b-col cols="12">
                                    <dropzone id="myVueDropzone" 
                                            ref="myVueDropzone" 
                                            class="mb-2" 
                                            :options="dropzoneOptions" 
                                            v-on:vdropzone-sending="sendingFile" 
                                            v-on:vdropzone-removed-file ="removeImage" 
                                            > 
                                            <input type="hidden" name="token" value="xxx">
                                        </dropzone>
                                </b-col>
                            </b-row>
                            <b-row class="mt-4" v-if="0">
                                <b-col cols="12">
                                    <h4>{{language_terms['SCANNED_DOCUMENTS']}}</h4>
                                </b-col>
                                <b-col cols="12">
                                    <b-table-simple striped hover responsive>
                                        <!-- <th>{{language_terms['SNO']}}</th> -->
                                        <th>Filename</th>
                                        <th>File Type</th>
                                        <!-- <th>{{language_terms['TIME_UPLOADED']}}</th> -->
                                        <th>Rows</th>
                                        <th>Valid Orders</th>
                                        <th>Total Orders</th>
                                        <th>Valid SKUs</th>
                                        <th>Total SKUs</th>
                                        <th></th>
                                        <b-tbody>
                                            <tr v-for="(row, upload_index) in scanned_documents" :key="upload_index">
                                                <!-- <td>{{upload_index + 1}}</td> -->
                                                <td><a :href="row.url" target="_blank">{{row.file_name}}</a></td>
                                                <td>{{row.classification}}</td>
                                                <!-- <td>{{row.time_uploaded_friendly}}</td> -->
                                                <td>{{row.dimension_height}}</td>
                                                <td>{{row.stat_orders_valid}}</td>
                                                <td>{{row.stat_orders_total}}</td>
                                                <td>{{row.stat_skus_valid}}</td>
                                                <td>{{row.stat_skus_total}}</td>
                                            </tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </card>    
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper" v-for="(row, upload_index) in scanned_documents" :key="upload_index">
                        <card>
                            <div slot="header" class="mb-0">
                                <h4>{{language_terms['UPLOAD_SUMMARY']}}</h4>
                            </div>
                            <b-row>
                                <b-col lg="8" class="mb-3">
                                    <base-input label="Filename"  v-model="row.file_name" type="text" disabled></base-input>
                                </b-col>
                                <b-col lg="4" class="mb-3">
                                    <base-input label="File Type"  v-model="row.classification" type="text" disabled></base-input>
                                </b-col>
                            </b-row>
                            <b-row v-if="row.classification == 'sales\\hktvm\\picklist' || row.classification == 'sales\\hktvm\\dailyorder'">
                                <b-col lg="2" class="mb-3" v-if="0">
                                    <base-input label="Rows" v-if="row.dimension_height != null" v-model="row.dimension_height" type="number"  disabled></base-input>
                                </b-col>
                                <b-col lg="2" class="mb-3">
                                    <base-input label="Total Waybills" v-if="row.stat_waybills != null" v-model="row.stat_waybills" type="number"  disabled></base-input>
                                </b-col>
                                <b-col lg="2" class="mb-3">
                                    <base-input label="Total Orders" v-if="row.stat_orders_total != null" v-model="row.stat_orders_total" type="number"  disabled></base-input>
                                </b-col>
                                <b-col lg="2" class="mb-3">
                                    <base-input label="Orders (Validated)" v-if="row.stat_orders_valid != null" v-model="row.stat_orders_valid" type="number"  disabled></base-input>
                                </b-col>
                                <b-col lg="2" class="mb-3">
                                    <base-input label="Orders (Processed)" v-if="row.stat_orders_processed != null" v-model="row.stat_orders_processed" type="number"  disabled></base-input>
                                </b-col>
                                <b-col lg="2" class="mb-3">
                                    <base-input label="Total SKUs" v-if="row.stat_skus_total != null"  v-model="row.stat_skus_total" type="number"  disabled></base-input>
                                </b-col>
                                <b-col lg="2" class="mb-3">
                                    <base-input label="SKUs Created" v-if="row.stat_skus_created != null" v-model="row.stat_skus_created" type="number"  disabled></base-input>
                                </b-col>
                                <b-col lg="12" class="mb-3" v-if="row.report_orders_invalid > 0 && row.report_orders_invalid != null">
                                    <base-input label="Skipped Orders">
                                        <textarea
                                        class="form-control"
                                        id="exampleFormControlTextarea1"
                                        rows="10"
                                        v-model="row.report_orders_invalid"
                                        disabled>
                                        </textarea>
                                    </base-input>
                                </b-col> 
                                <b-col lg="12" class="mb-3" v-if="row.report_skus_invalid > 0 && row.report_skus_invalid != null">
                                    <base-input label="Invalid SKUs">
                                        <textarea
                                        class="form-control"
                                        id="exampleFormControlTextarea1"
                                        rows="10"
                                        v-model="row.report_skus_invalid"
                                        disabled>
                                        </textarea>
                                    </base-input>
                                </b-col>
                            </b-row>
                            <b-row v-if="row.classification == 'sales\\hktvm\\waybills'">
                                <b-col lg="2" class="mb-3">
                                    <base-input label="Waybills (Found)" v-if="row.waybills_count != null"  v-model="row.waybills_count" type="number"  disabled></base-input>
                                </b-col>
                                <b-col lg="2" class="mb-3">
                                    <base-input label="Waybills (Created)" v-if="row.waybills_created != null"  v-model="row.waybills_created" type="number"  disabled></base-input>
                                </b-col>

                            </b-row>                             
                        </card>
                    </div>
                </b-col> 
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";


import Dropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    components:{
        Loading,
        Dropzone
    },
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms
        }),
    },
    data(){
        return{
            upload_count:0,
            loadingCounter:0,
            dropzoneOptions: 
            {
                maxFiles: 1000,
                url: "https://httpbin.org/post",
                thumbnailWidth: 200,
                addRemoveLinks: false,
                maxFilesize: 50,
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer '+ localStorage.access_token
                    }
            },
            scanned_documents:[]
        }
    },
    methods:{
        removeImage(file){
            //console.log(file)
        },
        async deleteFile(row, index)
        {
            this.loadingCounter++
            let upload_id = row.id
            let apiDocRemove = apiRoutes['UPLOAD_DOCUMENT_REMOVE']
            await axios.post(apiDocRemove, {upload_id:upload_id}, authHeader()).then(res => {
            if(res.data.code == 1)
            {
                alert(res.data.data)
                this.scanned_documents.splice(index, 1);
            }
            this.loadingCounter--
        })
        .catch(function(){

        });
        },
        async sendingFile(file, xhr, formData)
        {
            this.loadingCounter++

            let vm = this
            let apiUrl = apiRoutes['SALE_UPLOAD_DOCUMENT_HKTVM'];

            await axios.post(apiUrl, formData, authHeader()).then(res => 
            {
                if (res.data.code == 1)
                {
                    var upload_id = res.data.msg
                    var data = res.data.data 
                    vm.$refs.myVueDropzone.removeFile(file)

                    this.scanned_documents.push(data)
                }
                else
                {
                    alert('Please upload file again ... ' + file.name)
                    // console.log(file)
                    vm.$refs.myVueDropzone.removeFile(file)
                }
                })
                .catch(function()
                {

                });
            this.loadingCounter--
        }
        
}
}
</script>
